import axios from 'axios';
import store from '@/store/store';
import {useToast} from 'vue-toastification';
import router from '@/router';
import {useI18n} from 'vue-i18n';
import i18n from "@/utils/i18n";

const {t} = i18n.global;
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT
});

instance.interceptors.request.use(
  (request) => {
    const token = store.getters['auth/token'];
    if (token !== null) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response !== undefined && error.response.status === 401) {
      useToast().error(t('messages.loginRequired'));
      await router.push('/login');
      return Promise.reject(error.message || error);
    }
    useToast().error(error.message || error);
    return Promise.reject(error.message || error);
  }
);

export default instance;
